(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["optic-review-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('optic-review-form')) {
    class OpticReviewForm extends HTMLElement {
      #controller;

      connectedCallback() {
        this.#controller?.abort();
        this.#controller = new AbortController();
        const options = { signal: this.#controller.signal };
        const form = this.querySelector('form');
        const purchaseDate = this.querySelector('[data-review-purchase-date]');
        const feedback = this.querySelector('[data-review-success], [data-review-error]');
        if (feedback) feedback.focus();
        if (!form || !purchaseDate) return;

        purchaseDate.max = this.#today();
        purchaseDate.addEventListener('input', () => this.#validatePurchaseDate(purchaseDate), options);
        this.#timestamp();

        form.addEventListener('submit', (event) => {
          purchaseDate.max = this.#today();
          this.#validatePurchaseDate(purchaseDate);
          if (!form.reportValidity()) {
            event.preventDefault();
            return;
          }
          this.#timestamp();
        }, options);
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }

      #today() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      #validatePurchaseDate(input) {
        input.setCustomValidity(input.value && input.value > input.max ? this.dataset.dateError : '');
      }

      #timestamp() {
        const now = new Date();
        const utc = this.querySelector('[data-review-date]');
        const paris = this.querySelector('[data-review-date-paris]');
        if (utc) utc.value = now.toISOString();
        if (paris) {
          paris.value = new Intl.DateTimeFormat('fr-FR', {
            dateStyle: 'long', timeStyle: 'long', timeZone: 'Europe/Paris'
          }).format(now);
        }
      }
    }
    customElements.define('optic-review-form', OpticReviewForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["optic-tracking"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let widgetPromise;
    const loadWidget = () => {
      if (window.YQV5?.trackSingle) return Promise.resolve();
      if (widgetPromise) return widgetPromise;
      widgetPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timer = setTimeout(() => finish(false), 15000);
        const finish = success => {
          clearTimeout(timer);
          script.onload = null;
          script.onerror = null;
          if (success && window.YQV5?.trackSingle) resolve();
          else { script.remove(); reject(new Error('Tracking widget unavailable')); }
        };
        script.src = 'https://www.17track.net/externalcall.js';
        script.async = true;
        script.onload = () => finish(true);
        script.onerror = () => finish(false);
        document.head.append(script);
      }).catch(error => { widgetPromise = null; throw error; });
      return widgetPromise;
    };

    class OpticTracking extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.input = this.form.querySelector('input');
        this.button = this.form.querySelector('button');
        this.buttonLabel = this.querySelector('[data-button-label]');
        this.originalLabel = this.buttonLabel.textContent;
        this.status = this.querySelector('[data-status]');
        this.results = this.querySelector('[data-results]');
        this.widget = this.querySelector('[data-widget]');
        this.fallback = this.querySelector('[data-fallback]');
        this.form.addEventListener('submit', event => { event.preventDefault(); this.track(); });
        this.input.addEventListener('input', () => this.input.setCustomValidity(''));
        // Links from shipping emails can prefill ?tracking=NUMBER; no automatic lookup.
        const number = new URLSearchParams(window.location.search).get('tracking');
        if (number && number.length <= 50) this.input.value = number;
      }

      async track() {
        const number = this.input.value.trim();
        this.input.value = number;
        if (!this.form.reportValidity() || this.button.disabled) return;
        this.button.disabled = true;
        this.buttonLabel.textContent = this.dataset.busy;
        this.status.textContent = this.dataset.loading;
        this.fallback.hidden = false;
        this.fallback.href = this.form.action;
        this.results.hidden = true;
        this.widget.replaceChildren();
        try {
          await loadWidget();
          if (!this.isConnected) return;
          window.YQV5.trackSingle({
            YQ_ContainerId: this.widget.id,
            YQ_Height: 800,
            YQ_Fc: '0',
            YQ_Lang: this.dataset.language || 'fr',
            YQ_Num: number
          });
          const frame = this.widget.querySelector('iframe');
          if (!frame) throw new Error('No tracking frame');
          frame.title = this.querySelector('[data-results] h2').textContent;
          this.fallback.href = frame.src;
          this.results.hidden = false;
          this.status.textContent = '';
          this.results.querySelector('h2').focus({ preventScroll: true });
          this.results.scrollIntoView({ behavior: 'instant', block: 'start' });
        } catch {
          this.status.textContent = this.dataset.error;
        } finally {
          this.button.disabled = false;
          this.buttonLabel.textContent = this.originalLabel;
        }
      }
    }
    if (!customElements.get('optic-tracking')) customElements.define('optic-tracking', OpticTracking);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
class ReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-revs-track]');
    this.prev = this.querySelector('[data-revs-prev]');
    this.next = this.querySelector('[data-revs-next]');
    if (!this.track) return;
    const step = () => {
      const card = this.track.querySelector('.revs__card');
      return card ? card.getBoundingClientRect().width + 20 : 320;
    };
    this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
    this.next && this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
    this.update = this.update.bind(this);
    this.track.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    this.update();
  }
  update() {
    if (!this.track) return;
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max;
  }
}
if (!customElements.get('reviews-carousel')) customElements.define('reviews-carousel', ReviewsCarousel);

  } catch(e) { console.error(e); }
})();
})();
